import React from "react";
import ChoosePlan from "../components/Plan/choosePlan";

const PlanPage = () => {
  return <ChoosePlan />;
};

export default PlanPage;
